import { render, staticRenderFns } from "./SearchProjects.vue?vue&type=template&id=ee8731d6&scoped=true&lang=pug&"
import script from "./SearchProjects.vue?vue&type=script&lang=js&"
export * from "./SearchProjects.vue?vue&type=script&lang=js&"
import style0 from "./SearchProjects.vue?vue&type=style&index=0&id=ee8731d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8731d6",
  null
  
)

export default component.exports